<template>
  <div>
    <ParagraphBody
      v-if="requirement"
      :class="$style.requirementText"
      data-test-id="RequirementsDetail_requirement"
      :hasMargin="false"
    >
      {{ requirement }}
    </ParagraphBody>
    <div v-if="requiresSupervision">
      <Icon
        :class="$style.requiresSupervisionIcon"
        icon="info"
        inline
        :scale="1.25"
      />
      <ParagraphBody
        bodySize="small"
        :class="$style.requiresSupervisionText"
        data-test-id="RequirementsDetail_requiresSupervison"
        inline
      >
        Requires Supervision
      </ParagraphBody>
    </div>
  </div>
</template>

<script>
import { DarwinPoliciesNamesConsts, iOSPoliciesNamesConsts } from 'client/util/Constants';
import { Icon, ParagraphBody } from '@jumpcloud/ui-components';
import { cloneDeep, get } from 'lodash';
import PolicyUtil from 'client/policies/PolicyUtil';

export default {
  name: 'RequirementsDetail',

  components: {
    ParagraphBody,
    Icon,
  },

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    requirement() {
      const { item: { template } } = this;
      const policyName = get(template, 'name', '');
      const iOSAndDarwinPolicies = {
        ...cloneDeep(DarwinPoliciesNamesConsts),
        ...cloneDeep(iOSPoliciesNamesConsts),
      };
      const match = Object.values(iOSAndDarwinPolicies)
        .find(policy => policy.name === policyName);

      return (match && match.requirement && match.requirement.text) || '';
    },

    requiresSupervision() {
      return PolicyUtil.requiresSupervision(this.item);
    },
  },
};
</script>

<style module>
.requirementText::first-letter {
  text-transform: capitalize;
}

.requiresSupervisionIcon {
  position: relative;
  top: 0.25rem;
}

.requiresSupervisionText {
  display: inline;
}
</style>
